import React, { useEffect, useState } from "react";
import GroupedStackedBarChart from "../../../CHARTS/GroupedStackedBarChart";
const CauseWiseAFGraph = ({ data, causeWiseChart }) => {
  const [chartData, setChartData] = useState(null);
  const [chartDataYearWise, setChartDataYearWise] = useState(null);

  const transformYearlyData = (inputData) => {
    if (!inputData || !Array.isArray(inputData) || inputData.length === 0)
      return {};

    // Step 1: Collect all categories and data grouped by year and shift
    const categories = new Set();
    const groupsData = {};
    const categoryTotals = {};

    inputData.forEach((year) => {
      const yearKey = year.F_YEAR;
      groupsData[yearKey] = {};

      year.children.forEach((assetGroup) => {
        assetGroup.children.forEach((mainCause) => {
          const category = mainCause.MAIN_CAUSE_DESC;
          categories.add(category);

          if (!categoryTotals[category]) {
            categoryTotals[category] = 0;
          }

          mainCause.children.forEach((subCause) => {
            subCause.children.forEach((month) => {
              month.data.forEach((entry) => {
                const shift = entry.SHIFT;

                if (!groupsData[yearKey][shift]) {
                  groupsData[yearKey][shift] = {};
                }

                if (!groupsData[yearKey][shift][category]) {
                  groupsData[yearKey][shift][category] = 0;
                }

                groupsData[yearKey][shift][category] += 1;
                categoryTotals[category] += 1;
              });
            });
          });
        });
      });
    });

    // Step 2: Sort categories by total value in descending order
    const sortedCategories = Array.from(categories).sort(
      (a, b) => categoryTotals[b] - categoryTotals[a],
    );

    // Step 3: Format categories with the year range
    const yearRange = Object.keys(groupsData).sort().join(" | ");
    const categoriesArray = sortedCategories.map(
      (category) => `${yearRange.replace(/_/g, "-")}\n${category}`,
    );

    // Step 4: Define the desired order of shifts
    const shiftOrder = ["00_08", "08_16", "16_24"];

    // Step 5: Transform groupsData into the desired groups structure with sorted years and ordered shifts
    const groups = Object.keys(groupsData)
      .sort() // Sort years in ascending order (oldest first)
      .map((yearKey) => {
        const stacks = shiftOrder.map((shift) => ({
          name: shift,
          data: sortedCategories.map(
            (category) => groupsData[yearKey][shift]?.[category] || 0, // Use 0 if shift doesn't exist
          ),
        }));
        return {
          name: yearKey,
          stacks,
        };
      });

    // Step 6: Construct the final result
    return {
      categories: categoriesArray,
      groups,
    };
  };

  const transformYearlyDataWithoutShift = (inputData) => {
    if (!inputData || !Array.isArray(inputData) || inputData.length === 0) {
      return { categories: [], groups: [] };
    }

    // Step 1: Aggregate total count per year and per main cause
    const yearData = {}; // { "2023-24": { "Power Failure": 45, "Mechanical": 30, ... } }
    const categoryTotals = {}; // For sorting: { "Power Failure": 150, ... }

    inputData.forEach((year) => {
      const yearKey = year.F_YEAR;
      if (!yearData[yearKey]) {
        yearData[yearKey] = {};
      }

      year.children.forEach((assetGroup) => {
        assetGroup.children.forEach((mainCause) => {
          const category = mainCause.MAIN_CAUSE_DESC;

          // Initialize if not exists
          if (!yearData[yearKey][category]) yearData[yearKey][category] = 0;
          if (!categoryTotals[category]) categoryTotals[category] = 0;

          // Sum across all subcauses, months, and shifts
          mainCause.children.forEach((subCause) => {
            subCause.children.forEach((month) => {
              month.data.forEach((entry) => {
                yearData[yearKey][category] += 1;
                categoryTotals[category] += 1;
              });
            });
          });
        });
      });
    });

    // Step 2: Get all unique categories and sort by total descending
    const sortedCategories = Object.keys(categoryTotals).sort(
      (a, b) => categoryTotals[b] - categoryTotals[a],
    );

    // Step 3: Format categories with year range (e.g., "2022-23 - 2024-25\nPower Failure")
    const years = Object.keys(yearData).sort();
    const yearRange = years.length > 0 ? years.join(" | ") : "";
    const categories = sortedCategories.map(
      (cat) => `${yearRange.replace(/_/g, "-")}\n${cat}`,
    );

    // Step 4: Build groups — one group per year, one stack (total), with data for each category
    const groups = years.map((yearKey) => ({
      name: yearKey,
      stacks: [
        {
          name: "Total", // or yearKey if you prefer
          data: sortedCategories.map((cat) => yearData[yearKey][cat] || 0),
        },
      ],
    }));

    return {
      categories,
      groups,
    };
  };
  useEffect(() => {
    let temp = transformYearlyData(data);
    setChartData(temp);
  }, [data]);
  useEffect(() => {
    let temp = transformYearlyDataWithoutShift(data);
    setChartDataYearWise(temp);
  }, [data]);

  return (
    <div>
      <div className="papaDivNM" style={{ background: "rgba(0,0,0,0)" }}>
        {causeWiseChart && chartData && chartData?.groups?.length > 1 && (
          <GroupedStackedBarChart data={chartData} from={"AF"} />
        )}{" "}
        {!causeWiseChart &&
          chartDataYearWise &&
          chartDataYearWise?.groups?.length > 1 && (
            <GroupedStackedBarChart
              data={chartDataYearWise}
              from={"AF"}
              rotateText={0}
            />
          )}
      </div>
    </div>
  );
};
export default CauseWiseAFGraph;
